import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'src/app/components/auth/service/auth.service';
import { SharedDataService } from '../shared-service/shared-data.service';
import { catchError, map, of } from 'rxjs';
import * as moment from 'moment-timezone';
import { SocketService } from '../socket-service/socket-service.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const sharedDataService = inject(SharedDataService)
  const socket = inject(SocketService);

  const doLogout = () => {
    sharedDataService.saveUser(null);
    socket.disconnectSocket();
    authService.removeToken('access_token');
    authService.removeToken('refresh_token');
    router.navigate(['/login']);
  };
  
  return authService.me()
      .pipe(
        map((data) => {
          if (data && data.user) {
            sharedDataService.saveUser(data.user);
            socket.connectSocket();
            moment.tz.setDefault(data.user.timeZone);
            return true;
          } else {
            doLogout();
            return false;
          }
        }),
        catchError((error) => {
          doLogout();
          return of(false);
        })
      );
};
